import React from "react"
import { connect } from "react-redux"
import UserButton from "../../components/clock-in/user-button"

const mapStateToProps = state => ({
  ...state.clockIn
})

const mapDispatchToProps = dispatch => ({
  onClick: () => {
    if (window.limitLocation) {
      return (dispatch({ type: "CLOCK_IN.HEADER_USER_BUTTON_CLICKED" }))
    } else {
      return (dispatch({ type: "CLOCK_IN.NO_LIMIT_BUTTON_CLICKED" }))
    }
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UserButton)
